<template lang="pug">
div
  Navbar
  section.hero.is-medium.is-primary.is-bold
  .hero-body
    .container
      .columns.is-centered
        .column.is-half.is-centered
          h1.title.has-text-centered {{ article.title }}
          h3.title.is-5.has-text-centered by {{ article.author }}
          p.subtitle {{ article.date }}
          b-taglist
            b-tag(v-for="tag in article.tags", type="is-link", rounded) {{ tag["tag"][0]["text"] }}
  br
  section.container
    .columns.is-centered
      .column.is-half
        .columns.is-centered
          .column.is-half
            p.subtitle {{ article.description }}
          .column.is-half
            figure.image
              prismic-image(:field="article.image")
  br
  section.container
    .columns.is-centered
      .column.is-half
        prismic-rich-text(:field="article.body", :htmlSerializer="htmlSerializer")
  br
  Footer
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";

import prismicDOM from "prismic-dom";

const Elements = prismicDOM.RichText.Elements;

const htmlSerializer = function(type, element, content, children) {
  // Add a class to paragraph elements
  if (type === Elements.paragraph) {
    return `<p>${children.join("")}</p><br />`;
  }

  // Return null to stick with the default behavior for everything else
  return null;
};

export default {
  name: "Team",

  components: {
    Navbar,
    Footer
  },

  data() {
    return {
      htmlSerializer,
      article: {}
    };
  },

  methods: {
    // Fetch article from Prismic
    getArticle() {
      this.$prismic.client.getByID(this.$route.query.id).then(document => {
        this.article = {
          title: document.data.title ? document.data.title[0].text : "",
          author: document.data.author ? document.data.author[0].text : "",
          image: document.data.image,
          date: document.data.date,
          tags: document.data.tags,
          description: document.data.description
            ? document.data.description[0].text
            : "",
          body: document.data.body
        };
      });
    }
  },

  created() {
    this.getArticle();
  }
};
</script>
